import { render, staticRenderFns } from "./Form60DetailsActivity.vue?vue&type=template&id=55072906&scoped=true&"
import script from "./Form60DetailsActivity.vue?vue&type=script&lang=js&"
export * from "./Form60DetailsActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=55072906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55072906",
  null
  
)

export default component.exports